"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaQueryContext = exports.default = void 0;
var react_1 = __importStar(require("react"));
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var styles_1 = require("@mui/material/styles");
var index_1 = __importDefault(require("./index"));
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var MediaQueryContext = (0, react_1.createContext)({
  md: false
});
exports.MediaQueryContext = MediaQueryContext;
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$normalize = _ref.normalize,
    normalize = _ref$normalize === void 0 ? true : _ref$normalize;
  var md = (0, useMediaQuery_1.default)('(min-width:768px)');
  return react_1.default.createElement(MediaQueryContext.Provider, {
    value: {
      md: md
    }
  }, react_1.default.createElement(styles_1.ThemeProvider, {
    theme: index_1.default
  }, normalize && react_1.default.createElement(CssBaseline_1.default, null), children));
};
exports.default = ThemeProvider;